import { ActionItem, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import type { Option } from 'modules/core/components/Popover/Content'
import i18n from 'modules/core/lib/i18n'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

import ItemToggler from './ItemToggler'
import Options from './Options'
import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  field: CustomField | Field
  actions: Option[]
  assignToResource?: () => void
  assigned: boolean
  canAssignToResource: boolean
  hideDragAndDropIcon?: boolean
}

function getTypeLabel(field: CustomField | Field): string {
  const fieldType = field.attributes.field_type

  switch (fieldType) {
    case FieldTypes.text:
      return i18n.t('settings.custom_fields.new.labels.text')
    case FieldTypes.longText:
      return i18n.t('settings.custom_fields.new.labels.long_text')
    case FieldTypes.date:
      return i18n.t('settings.custom_fields.new.labels.date')
    case FieldTypes.cents:
      return i18n.t('settings.custom_fields.new.labels.number')
    case FieldTypes.rating:
      return i18n.t('settings.custom_fields.new.labels.rating')
    case FieldTypes.checkbox:
      return i18n.t('settings.custom_fields.new.labels.checkbox')
    case FieldTypes.singleChoice:
      return i18n.t('settings.custom_fields.new.labels.single_choice')
    default:
      return ''
  }
}

export const Item = observer(
  ({
    field,
    actions,
    assignToResource,
    assigned,
    canAssignToResource,
    hideDragAndDropIcon,
  }: Props) => {
    const subtitleLabel = field.attributes.required
      ? i18n.t('ats.custom_fields.label.required')
      : i18n.t('ats.custom_fields.label.optional')

    return (
      <div className={cx(styles.item)}>
        <ActionItem showIcon={false} whiteDisabled>
          <Box width="full">
            <Box
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
              overflowX="hidden"
              width="full"
            >
              <Box overflowX="hidden" paddingRight="s16" gap="s4">
                <div className={cx(styles.dragHandle)}>
                  {!hideDragAndDropIcon && <Icon.Medium icon="drag-and-drop" />}
                </div>
                <Text size="300" weight="medium">
                  {field.attributes.label}
                </Text>
                {subtitleLabel && (
                  <Text size="400" weight="medium" color="grey600">
                    {subtitleLabel}
                  </Text>
                )}
                <Text size="200" weight="medium" color="grey600">
                  {getTypeLabel(field)}
                </Text>
              </Box>
              <Box gap="s16">
                <ItemToggler
                  assigned={assigned}
                  assignToResource={assignToResource}
                  canAssignToResource={canAssignToResource}
                />
                <Options actions={actions} />
              </Box>
            </Box>
          </Box>
        </ActionItem>
      </div>
    )
  }
)
